"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _TextEffect2 = _interopRequireDefault(require("./TextEffect"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var NoneTextEffect = /*#__PURE__*/function (_TextEffect) {
  (0, _inherits2["default"])(NoneTextEffect, _TextEffect);

  var _super = _createSuper(NoneTextEffect);

  function NoneTextEffect() {
    (0, _classCallCheck2["default"])(this, NoneTextEffect);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(NoneTextEffect, null, [{
    key: "apply",
    value: function apply(finalContext, effectContext, frameNumber, contentFrameData, layerTransformData) {
      this.drawTextLines(finalContext, contentFrameData);
    }
  }]);
  return NoneTextEffect;
}(_TextEffect2["default"]);

exports["default"] = NoneTextEffect;